import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stripeApi } from '../apis/stripe.api';

const SubscriptionRenewSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleSubscription = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const sessionId = searchParams.get('session_id');
      console.log('sessionId', sessionId);
      console.log('searchParams', searchParams);
      if (!sessionId) {
        console.error('No session ID found in URL');
        setError('Invalid session');
        setLoading(false);
        return;
      }

      try {
        const response = await stripeApi.handleSubscriptionSuccess(sessionId);
        console.log('***** Subscription renewal success response:', response);
        
        setLoading(false);
        // Redirect to login after 5 seconds
        setTimeout(() => {
          navigate('/login');
        }, 5000);
      } catch (error) {
        console.error('Subscription renewal processing failed:', error);
        setError(error.message || 'Failed to process subscription renewal');
        setLoading(false);
      }
    };

    handleSubscription();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
          <h2 className="text-2xl font-bold text-center text-gray-800">
            Processing Your Renewal
          </h2>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
          <p className="text-center text-gray-600">
            Please wait while we confirm your subscription renewal...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
          <h2 className="text-2xl font-bold text-center text-red-600">
            Renewal Error
          </h2>
          <p className="text-center text-gray-600">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="w-full px-4 py-2 text-white bg-primary rounded hover:bg-primary-dark transition-colors"
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
        <h2 className="text-2xl font-bold text-center text-green-600">
          Subscription Renewed Successfully!
        </h2>
        <p className="text-center text-gray-600">
          Thank you for renewing your subscription. Redirecting you to login...
        </p>
      </div>
    </div>
  );
};

export default SubscriptionRenewSuccess;